<template>
  <div class="background">
    <div class="login_box">
      <el-row>
        <el-col :span="6">
          <el-image :src="require('../assets/image/logo.png')"></el-image>
        </el-col>
        <el-col :span="16">
          <h2>华连生足部健康管理系统</h2>
          <label style="align-content: center">您的双脚，我来呵护</label>
        </el-col>
      </el-row>
      <el-form>
        <div style="margin-top: 15px; display: flex;justify-content: flex-start" @change="setOrg">
          <el-radio-group v-model="orgType">
            <el-radio :label="1">集团人员</el-radio>
            <el-radio :label="2">分公司人员</el-radio>
            <el-radio :label="3">店长</el-radio>
            <el-radio :label="4">技师</el-radio>
          </el-radio-group>
        </div>
        <div style="margin-top: 15px;display: flex">
          <label style="color: #FA5858">*</label>
          <el-select value filterable v-model="employee.orgId" placeholder="请选择区域" style="margin-left: 5px;width: 200px"
            size="mini" @change="getArea">
            <el-option v-for="item in area" :key="item.id" :label="item.orgName" :value="item.id">
            </el-option>
          </el-select>
          <label style="color: #FA5858;margin-left: 5px;">*</label>
          <el-select v-model="employee.shopId" :disabled="isDisable" value filterable placeholder="请选择门店"
            style="margin-left: 5px;width: 200px" size="mini" @change="getShop">
            <el-option v-for="org in shop" :key="org.id" :label="org.orgName" :value="org.id">
            </el-option>
          </el-select>
        </div>

        <div style="display: flex;justify-items: flex-start;margin-top: 15px">
          <label style="color: #FA5858;">*</label>
          <el-input size="mini" v-model="employee.userName" placeholder="请输入姓名"
            style="width: 50%;margin-left: 5px;"></el-input>
          <label style="color: #FA5858;margin-left: 5px;">*</label>
          <el-input size="mini" v-model="employee.phone" placeholder="请输入手机号码" style="width: 50%;margin-left: 5px;"
            @blur="checkPhone"></el-input>
        </div>
        <div style="margin-top: 15px">
          <label style="color: #FA5858;">*</label>
          <el-input size="mini" v-model="employee.password" placeholder="6-16位密码，区分大小写" style="width:385px"></el-input>
          <label style="color: #FA5858;">*</label>
          <el-input size="mini" v-model="employee.password_again" placeholder="确认密码"
            style="width: 385px;margin-top: 15px"></el-input>
        </div>
        <div style="margin-top: 15px;display: flex;justify-content: flex-start">
          <label style="color: #FA5858;">*</label>
          <el-input size="mini" placeholder="输入验证码" style="width: 60%;margin-left: 5px;"
            v-model="employee.checkCode"></el-input>
          <el-button size="mini" style="width: 125px;margin-left: 20px" @click="getCheckCode">获取验证码</el-button>
        </div>
        <div style="margin-top: 15px;display: flex;justify-content: flex-start;align-items: center">
          <label style="color: #FA5858;">*</label>
          <label style="font-size: 12px;color: #3a8ee6;width: 80px;margin-left: 5px;">注册说明:</label>
          <el-input size="mini" placeholder="请填写具体职位" v-model="employee.comment"></el-input>
        </div>
        <div style="margin-top: 15px;display: flex;justify-content: space-between;align-items: center">
          <el-button style="width: 140px;" @click="createEmployee" :disabled="doubleClick">注册</el-button>
          <router-link class="link" to="/login">使用已有账号登录</router-link>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      area: [],
      shop: [],
      roles: [],
      value: '',
      orgType: 4,
      employee: {
        orgId: '',
        userName: '',
        roleId: 2,
        phone: '',
        password: '',
        password_again: '',
        shopId: '',
        loginId: '',
        checkCode: '',
        comment: ''
      },
      areaId: '',
      shopId: '',
      isDisable: false,
      doubleClick: false,
      phoneExist: false
    }
  },
  methods: {
    async checkPhone() {
      const { data: res } = await this.$http.get(`users/checkPhone/${this.employee.phone}`);
      if (res.code === 999) {
        this.$message.warning(res.msg);
        this.phoneExist = true;
      }
      if (res.code === 200) {
        this.$message.success(res.msg);
      }
    },
    setOrg() {
      if (this.orgType === 1) {
        this.isDisable = true;
        this.employee.shopId = '';
        for (let i = 0; i < this.area.length; i++) {
          if (this.area[i].orgName === '华连生集团') {
            this.employee.orgId = this.area[i].id;
          }
        }
      }
      if (this.orgType === 2) {
        this.isDisable = true;
        this.employee.orgId = '';
        this.employee.shopId = '';
      }
      if (this.orgType === 3) {
        this.isDisable = false;
        this.employee.orgId = '';
        this.employee.shopId = '';
      }
      if (this.orgType === 4) {
        this.isDisable = false;
        this.employee.orgId = '';
        this.employee.shopId = '';
      }
    },
    async loadAreaOrgs() {
      const { data: res } = await this.$http.get('orgs/area');
      if (res.code === 200) {
        this.area = res.data;
      }
    },
    async loadRoles() {
      const { data: res } = await this.$http.get('roles');
      if (res.code === 200) {
        this.roles = res.data;
      }
    },
    async getCheckCode() {
      if (this.employee.phone === '') {
        return this.$message.warning("请填写手机号");
      }
      const { data: res } = await this.$http.get(`/users/getCode/${this.employee.phone}`);
      if (res.code === 200) {
        return this.$message.success("验证码已发送您的手机，请注意查看！");
      }
    },
    async getArea(data) {
      this.employee.orgId = data;
      this.areaId = data;
      const { data: res } = await this.$http.get(`orgs/shop/${data}`);
      this.shop = res.data;
    },
    getShop(data) {
      this.employee.shopId = data;
      this.shopId = data;
    },
    getRoleType(data) {
      this.employee.roleId = data;
    },
    async createEmployee() {
      if (this.orgType === 1 && this.employee.orgId === '') {
        return this.$message.warning("请选择区域！")
      }
      if (this.orgType === 2 && this.employee.orgId === '') {
        return this.$message.warning("请选择区域！")
      }
      if ((this.orgType === 3 || this.orgType === 4) && this.employee.shopId === '') {
        return this.$message.warning("请选择门店！")
      }
      if (this.employee.userName === '') {
        return this.$message.warning("请填写姓名！")
      }
      if (this.employee.phone === '') {
        return this.$message.warning("请填写手机！")
      }
      if (this.employee.password === '') {
        return this.$message.warning("请填写密码！")
      }
      if (this.employee.password === '') {
        return this.$message.warning("请填写确认密码！")
      }
      if (this.employee.password !== this.employee.password_again) {
        return this.$message.warning("密码和确认密码不一致！")
      }
      if (this.employee.checkCode === '') {
        return this.$message.warning("请填写验证码！")
      }
      if (this.employee.comment === '') {
        return this.$message.warning("请填写注册说明！")
      }
      if (this.phoneExist === true) {
        return this.$message.warning("此手机号已注册！")
      }

      if (this.orgType === 1) {
        this.employee.comment = "集团人员，" + this.employee.comment;
      }
      if (this.orgType === 2) {
        this.employee.comment = "分公司人员，" + this.employee.comment;
      }
      if (this.orgType === 3) {
        this.employee.comment = "店长，" + this.employee.comment;
      }
      if (this.orgType === 4) {
        this.employee.comment = "技师，" + this.employee.comment;
      }

      this.doubleClick = true;
      const { data: res } = await this.$http.post(`user`, this.employee);
      if (res.code === 200) {
        this.$message.success("注册成功，请等待审核！");
        await this.$router.push("/login");
      }
      if (res.code === 401) {
        this.$message.error(res.msg);
      }
      if (res.code === 500) {
        this.$message.error("注册失败，请重新注册！");
      }
      setTimeout(() => {
        this.doubleClick = false;
      }, 3000
      )
    }
  },
  created() {
    this.loadAreaOrgs();
    // this.loadRoles();
  }
}
</script>

<style scoped>
.background {
  background-image: url("../assets/image/login.png");
  height: 100%;
  overflow-y: auto;
}

.login_box {
  position: absolute;
  width: 400px;
  height: 300px;
  left: 50%;
  top: 40%;
  margin-left: -200px;
  margin-top: -140px;
  border: 1px;
}

.select>>>.el-input__inner {
  height: 30px;
  line-height: 30px;

}

.btn>>>.el-button,
.el-button--default {
  padding: 5px 5px 5px 5px;
}

.link {
  color: #409EFF;
  -webkit-box-direction: normal;
  -webkit-box-align: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  -webkit-box-orient: horizontal;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/components/Registry.vue